import React from 'react'
import { ComponentDynamicKey, TypeComponentDynamic } from '../../lib/types/component-dynamic'
import { ContentProps } from '../renderer'
import { GGOTryComponent } from './ggo-try'
import { ToolSuiteComponent } from './tool-suite'
import { BtsAgents25Component } from './bts-agents-25'
import { BtsKeychainComponent } from './bts-agents-25-keychain'
import { GrammarlyAtWork25Component } from './grammarly-at-work-25'
import { PersistentClientCtaSection } from './persistent-client-cta-section'
import { TrialCtaButton } from './trial-cta-button'

export const ComponentDynamic: React.FC<ContentProps<TypeComponentDynamic>> = (props) => {
  switch (props.structure.fields.key) {
    case ComponentDynamicKey.GGOTryIt:
      return <GGOTryComponent />
    case ComponentDynamicKey.ToolSuite:
      return <ToolSuiteComponent />
    case ComponentDynamicKey.BtsAgents25:
      return <BtsAgents25Component />
    case ComponentDynamicKey.BtsKeychain:
      return <BtsKeychainComponent />
    case ComponentDynamicKey.GrammarlyAtWork25:
      return <GrammarlyAtWork25Component />
    case ComponentDynamicKey.PersistentClientCtaSection:
      return <PersistentClientCtaSection />
    case ComponentDynamicKey.TrialCtaButton:
      return <TrialCtaButton />
    default:
      return null
  }
}
